export default __webpack_public_path__ + "static/media/file-plus-w.0dcbd590.svg";